import { fetchCart } from '@/features/shop/services/Cart/fetchers'
import {
  type StoreParamsAsKey,
  useStoreParams,
  type StoreParams,
} from '@/features/shared/utils/dataFetching/storeParams'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { useGlobalDefaultShoppingAddress } from '@/features/account/services/Addresses/hooks'
import { minutesToMilliseconds } from 'date-fns/minutesToMilliseconds'
import { type Cart } from '@/features/shop/services/Cart/types'

export const CartQuery = 'Cart'
export type CartQueryKey = readonly [typeof CartQuery, StoreParams, string]

export const cartQueryOptions = ({ state, storeParams }: StoreParamsAsKey & { state: string }) =>
  queryOptions({
    queryKey: [CartQuery, storeParams, state] as const,
    queryFn: fetchCart,
    staleTime: minutesToMilliseconds(15),
  })

type CartProps<T = Cart> = {
  selectFn?: (data: Cart) => T
  enabled?: boolean
}

export const useQueryCart = <T = Cart>({ selectFn, enabled: enabledProp }: CartProps<T> = {}) => {
  const storeParams = useStoreParams()

  const { store_location_id } = storeParams
  const state = useGlobalDefaultShoppingAddress().state ?? ''

  return useQuery({
    ...cartQueryOptions({ storeParams, state }),
    enabled:
      enabledProp !== undefined
        ? enabledProp && Boolean(store_location_id)
        : Boolean(store_location_id),
    select: selectFn,
    meta: {
      observerThreshold: 400,
    },
  })
}
